import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const slides = [
  { id: 1, image: "/assets/carrousel/image1.jpg" },
  { id: 2, image: "/assets/carrousel/image2.jpg" },
  { id: 3, image: "/assets/carrousel/image3.jpg" },
];

export default function Banner() {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setDirection(1);
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const variants = {
    enter: (direction) => ({
      x: direction > 0 ? 50 : -50,
      opacity: 0,
      scale: 0.98,
    }),
    center: {
      x: 0,
      opacity: 1,
      scale: 1,
      transition: { duration: 0.4, ease: "easeInOut" },
    },
    exit: (direction) => ({
      x: direction > 0 ? -50 : 50,
      opacity: 0,
      scale: 0.98,
      transition: { duration: 0.4, ease: "easeInOut" },
    }),
  };

  const getTitleColor = () => {
    const currentSlideId = slides[current].id;
    if (currentSlideId === 3) return "text-primary";
    if (currentSlideId === 1) return "text-deepblue";
    return "text-white";
  };

  return (
    <div className="justify-center">
    <div className="relative justify-center overflow-hidden mx-auto w-11/12 h-[400px] md:h-[600px] rounded-2xl shadow-lg p-5 mt-5 mb-5">
      <AnimatePresence custom={direction}>
        <motion.div
          key={slides[current].id}
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          className="absolute inset-0 w-full h-full"
        >
          <motion.img
            src={slides[current].image}
            alt={`Slide ${slides[current].id}`}
            className="w-full h-full object-cover md:object-contain lg:object-cover"
            initial={{ scale: 1 }}
            animate={{ scale: 1.03 }}
            transition={{ duration: 5, ease: "easeInOut" }}
          />
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="absolute inset-0 flex flex-col items-center justify-center text-center py-5"
          >
            <h1 className={`text-6xl font-extrabold font mb-2 tracking-wide uppercase ${getTitleColor()}`}>Kim Anh</h1>
            <h2 className={`"text-3xl font-semibold tracking-widest ${getTitleColor()}`}>Atelier</h2>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      {/* Bullets */}
      <div className="absolute bottom-4 w-full flex justify-center gap-3">
        {slides.map((_, index) => (
          <motion.button
            key={index}
            onClick={() => {
              setDirection(index > current ? 1 : -1);
              setCurrent(index);
            }}
            className={`w-3 h-3 rounded-full ${current === index ? "bg-light" : "bg-dark/50"}`}
            whileHover={{ scale: 1.3 }}
            animate={{ backgroundColor: current === index ? "#0F5C9C" : "#E0DDDA" }}
            transition={{ duration: 0.3 }}
          />
        ))}
      </div>
    </div>
    </div>
  );
}
